(() => {
  const GTM_CONTAINER_ID = 'GTM-WKL2KMC3';
  const CONSTANT_CONTACT_ACCOUNT_ID = '84f2bbf7120facbb535b8de97d7bbc43';

  let consentInitialized = false;
  let gtmLoaded = false;
  let constantContactLoaded = false;
  let previousMarketingAllowed = null;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  function loadGoogleTagManager() {
    if (gtmLoaded) return;

    gtmLoaded = true;
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(GTM_CONTAINER_ID)}`;
    document.head.appendChild(script);
  }

  function loadConstantContact() {
    if (constantContactLoaded) return;

    constantContactLoaded = true;
    window._ctct_m = CONSTANT_CONTACT_ACCOUNT_ID;

    const script = document.createElement('script');
    script.id = 'signupScript';
    script.src = 'https://static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  function updateNewsletterConsentMessage(marketingAllowed) {
    document.querySelectorAll('[data-ctct-consent-message]').forEach((message) => {
      message.hidden = marketingAllowed;
    });
  }

  function applyConsent() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (
      !privacy ||
      typeof privacy.analyticsProcessingAllowed !== 'function' ||
      typeof privacy.marketingAllowed !== 'function' ||
      typeof privacy.preferencesProcessingAllowed !== 'function' ||
      typeof privacy.saleOfDataAllowed !== 'function'
    ) {
      return false;
    }

    const analyticsAllowed = privacy.analyticsProcessingAllowed();
    const marketingAllowed = privacy.marketingAllowed();
    const preferencesAllowed = privacy.preferencesProcessingAllowed();
    const advertisingAllowed = marketingAllowed && privacy.saleOfDataAllowed();
    const consentCommand = consentInitialized ? 'update' : 'default';

    window.gtag('consent', consentCommand, {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_storage: advertisingAllowed ? 'granted' : 'denied',
      ad_user_data: advertisingAllowed ? 'granted' : 'denied',
      ad_personalization: advertisingAllowed ? 'granted' : 'denied',
      functionality_storage: preferencesAllowed ? 'granted' : 'denied',
      personalization_storage: preferencesAllowed ? 'granted' : 'denied',
      security_storage: 'granted',
    });

    consentInitialized = true;

    if (analyticsAllowed || advertisingAllowed) {
      loadGoogleTagManager();
    }

    if (marketingAllowed) {
      loadConstantContact();
    }

    updateNewsletterConsentMessage(marketingAllowed);

    // A third-party script cannot be fully unloaded. Reload after a visitor
    // revokes marketing consent so Constant Contact is absent on the new page.
    if (previousMarketingAllowed === true && !marketingAllowed && constantContactLoaded) {
      window.setTimeout(() => window.location.reload(), 100);
    }

    previousMarketingAllowed = marketingAllowed;
    return true;
  }

  function loadCustomerPrivacyApi() {
    if (applyConsent()) return;

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) applyConsent();
      });
    }
  }

  document.addEventListener('shopifyCustomerPrivacyApiLoaded', applyConsent);
  document.addEventListener('visitorConsentCollected', applyConsent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCustomerPrivacyApi, { once: true });
  } else {
    loadCustomerPrivacyApi();
  }
})();
